import RevealInformationPageContainer from '../../containers/revealInformationPage/RevealInformationPageContainer';

const RevealInformationPage = () => <RevealInformationPageContainer/>;

export default RevealInformationPage;